module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ODE TO INSPIRATION")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("Then the imagination withdraws, drifts across the table")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("to investigate the glass flowers rolled in cloth tape.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("It hovers, probes the petals, some like galaxies,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("some like figs or seashells. Dutiful and penitent,")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("it shimmers back across the gulf of air,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("without a metaphor, to doze away the afternoon.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("Rain.")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("Unseasonably hot day.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("Imagination is the builder, the worker bee,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("but inspiration is the queen.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("And when she leaves me, where does she go")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("if not back to the hive to gorge on royal jelly,")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("back into her cave of winds, accumulating")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("density, growing richer and darker,")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("like mercury in the bloodstream,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("like extravagant honey.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a8813e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 72
// module chunks = 0